var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyPockets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1066.6667 933.33331",
    height: 933.33331,
    width: 1066.6667,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,933.33333)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fillOpacity: 0,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 8000,0 H 0 V 7000 H 8000 V 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#f9f8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2030.39,1125.85 h 3475.57 c 1173.33,682.4 1511.23,1517.19 1396.37,1922.36 -144.44,509.49 -510,660 -900,927.7 -468.92,321.89 351.19,1152.3 268.89,1592.3 -130.5,698.2 -1126.8,653.04 -2114.97,-1093.93 -416.56,-736.43 -987.63,638.97 -1453.33,800.57 -432.4,150 -1737.475,-527.86 -387.54,-2054.3 429.76,-485.96 -1689.13,-690.56 -284.99,-2094.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#f9f8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1629.11,3443.35 c -6.62,59.76 -24.05,100.49 -65.44,122.93 -122.71,66.55 -430.64,-41.42 -558.68,-207.99 -178.549,-232.28 -15.701,-589.48 157.75,-612.28 201.81,-26.54 500.51,388.78 466.37,697.34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#ddd6ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 4158.39,965.781 H 2479.61 4158.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#ddd6ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 4158.39,955.781 H 2479.61 v 20 h 1678.78 v -20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#ddd6ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 2982.4,813.391 H 2289.63 2982.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#ddd6ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2982.4,803.391 h -692.77 v 20 h 692.77 v -20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#ddd6ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 4876.02,813.391 H 3428.46 4876.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#ddd6ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 4876.01,803.391 H 3428.46 v 20 h 1447.55 v -20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#ddd6ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 2189.2,963.441 H 1750.85 2189.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#ddd6ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2189.2,953.441 h -438.34 v 20 h 438.34 v -20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#ddd6ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 5786.22,965.781 H 4493.73 5786.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#ddd6ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 5786.22,955.781 H 4493.73 v 20 h 1292.49 v -20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 6520.34,1115.85 H 1279.65 v 20 h 5240.69 v -20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5847.19,1115.85 h -91.9 v 20 h 91.9 v -20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#f9f8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5165.72,1125.85 h 461.21 -461.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5626.93,1115.85 h -461.21 v 20 h 461.21 v -20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2684.57,1115.85 h -140.01 v 20 h 140.01 v -20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#f9f8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 2815.92,1125.85 H 4493.73 2815.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 4493.73,1115.85 H 2815.92 v 20 h 1677.81 v -20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4810.98,6357.26 h -20 v 56.1 h 20 v -56.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4810.98,6020.68 h -20 v 56.09 h 20 v -56.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4722.2,6333.47 -28.04,48.58 17.32,10 28.05,-48.58 -17.33,-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4890.5,6041.98 -28.05,48.58 17.32,10 28.05,-48.58 -17.32,-10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4674.54,6278.48 -48.59,28.05 10,17.32 48.59,-28.05 -10,-17.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4966.02,6110.19 -48.58,28.04 10,17.33 48.58,-28.05 -10,-17.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4660.75,6207.02 h -56.1 v 20 h 56.1 v -20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4997.33,6207.02 h -56.1 v 20 h 56.1 v -20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4635.95,6110.19 -10,17.32 48.59,28.05 10,-17.33 -48.59,-28.04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4927.44,6278.48 -10,17.32 48.58,28.05 10,-17.32 -48.58,-28.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4711.48,6041.98 -17.32,10 28.04,48.58 17.33,-10 -28.05,-48.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4879.77,6333.47 -17.32,10 28.05,48.58 17.32,-10 -28.05,-48.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1273.44,4261.61 c 32.52,-13.46 58.59,-39.51 72.05,-72.05 13.45,32.54 39.51,58.59 72.05,72.05 -32.54,13.46 -58.6,39.52 -72.05,72.05 -13.46,-32.53 -39.53,-58.59 -72.05,-72.05 z m 82.05,-122.57 h -20 c 0,62.07 -50.5,112.57 -112.57,112.57 v 20 c 0.12,0 0.25,0 0.38,0 61.89,0.21 112.19,50.63 112.19,112.57 h 20 c 0,-62.07 50.49,-112.57 112.55,-112.57 v -20 c -0.12,0 -0.25,0 -0.38,0 -61.88,-0.21 -112.17,-50.62 -112.17,-112.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6786.9,4040.64 c -27.87,0 -50.54,-22.67 -50.54,-50.54 0,-27.87 22.67,-50.54 50.54,-50.54 27.87,0 50.55,22.67 50.55,50.54 0,27.87 -22.68,50.54 -50.55,50.54 z m 0,-121.08 c -38.89,0 -70.54,31.64 -70.54,70.54 0,38.9 31.65,70.54 70.54,70.54 38.9,0 70.55,-31.64 70.55,-70.54 0,-38.9 -31.65,-70.54 -70.55,-70.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5600.35,5353.53 -19.98,0.89 1.2,27 19.98,-0.89 -1.2,-27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    style: {
      fill: "#ffd4cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 6623.06,4786 c 0,0 -82.45,3.45 -154.44,31.9 -139.61,55.19 -197.76,203.25 -343.75,249.54 -145.99,46.29 -297.82,-182.12 -297.82,-182.12 l -16.14,-42.78 c 0,0 28.52,27.84 68.77,53.33 60.35,38.2 79.28,-5.26 79.28,-5.26 5.53,12.89 12.97,23.86 20.76,33.06 -1.33,-4.43 -2.38,-8.92 -2.99,-13.48 -6.7,-50.22 8.78,-78.52 21.9,-92.54 2.21,19.66 13.33,41.52 29.72,63.33 -11.94,-40.44 -16.44,-83.26 0.81,-115.37 23.98,-44.62 53.04,-58.56 71.86,-62.27 -13.26,23.63 -15.57,60.24 -10.67,99.97 29.99,-144.63 188.63,-145.9 188.63,-145.9 0,0 -46.63,30.39 -94.66,120.42 21.41,-28.63 48.36,-56.22 85.1,-74.3 85.9,-42.27 143.09,-16.5 156.15,-5.1 -59.37,17.73 -107.82,49.66 -145.35,82.86 2.51,-1.4 5.02,-2.8 7.54,-4.17 217.06,-117.34 335.3,8.88 335.3,8.88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#ffd4cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4592.01,5517.79 c 0,0 64.19,-51.87 137.03,-78.06 141.27,-50.77 282.73,21.98 422.91,-39.69 140.19,-61.67 103.32,-333.45 103.32,-333.45 l -16.14,-42.78 c 0,0 -3.01,39.74 -16.4,85.46 -20.08,68.55 -63.01,48.42 -63.01,48.42 4.37,13.33 6.03,26.48 6.26,38.53 -1.93,-4.2 -4.11,-8.27 -6.67,-12.09 -28.13,-42.13 -58.44,-53.16 -77.55,-55.02 11.32,16.23 17.41,39.98 19.51,67.18 -17.74,-38.25 -42.65,-73.37 -76.81,-86.08 -47.48,-17.67 -78.51,-8.94 -95.09,0.71 25.57,8.98 51.48,34.94 74.05,68.01 -118.05,-88.79 -238,15.05 -238,15.05 0,0 55.08,-7.98 150.62,27.88 -34.99,-7.35 -73.45,-10.26 -112.98,0.43 -92.41,24.99 -118.33,82.12 -120.6,99.31 56.28,-25.9 113.75,-33.93 163.86,-33.8 -2.81,0.61 -5.63,1.21 -8.43,1.86 -240.47,55.26 -245.88,228.13 -245.88,228.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    style: {
      fill: "#ffd259",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5639.89,4589.37 c -162.85,-73.63 -354.56,-1.31 -428.19,161.54 -73.63,162.85 -1.31,354.55 161.54,428.19 162.84,73.63 354.55,1.31 428.18,-161.54 73.64,-162.85 1.31,-354.55 -161.53,-428.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    style: {
      fill: "#ff9d45",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5506.52,4550.59 c -81.37,0 -161.68,29.77 -224.38,86.71 l 13.43,14.81 c 92.65,-84.13 226.2,-105.17 340.2,-53.62 40.44,18.28 75.78,44.23 105.04,77.11 l 14.94,-13.29 c -31.13,-34.99 -68.72,-62.6 -111.74,-82.05 -44.11,-19.94 -90.98,-29.67 -137.49,-29.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    style: {
      fill: "#ff9d45",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5785.59,4701.31 -16.74,10.95 c 9.95,15.19 18.62,31.35 25.79,48.04 l 18.38,-7.91 c -7.63,-17.74 -16.86,-34.92 -27.43,-51.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    style: {
      fill: "#ff9d45",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5801.55,4990.71 c -2.77,7.65 -5.88,15.3 -9.24,22.73 -59.17,130.85 -199.11,204.74 -340.3,179.7 l -3.5,19.69 c 150.29,26.63 299.09,-51.96 362.02,-191.15 3.58,-7.89 6.88,-16.02 9.83,-24.16 l -18.81,-6.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    style: {
      fill: "#ff9d45",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5174.19,4854.57 c -12.6,141.15 65.74,275.23 194.93,333.64 6.49,2.94 13.06,5.66 19.64,8.15 l 7.09,-18.7 c -6.19,-2.35 -12.37,-4.9 -18.49,-7.67 -121.45,-54.92 -195.1,-180.96 -183.25,-313.65 l -19.92,-1.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    style: {
      fill: "#ff9d45",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5282.14,4637.3 c -33.81,30.69 -60.58,67.53 -79.55,109.49 -7.99,17.65 -14.47,36.04 -19.25,54.65 l 19.37,4.98 c 4.5,-17.49 10.59,-34.78 18.1,-51.39 17.84,-39.45 43,-74.08 74.76,-102.92 l -13.43,-14.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    style: {
      fill: "#ffe159",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5619.26,4634.88 c -66.58,-30.03 -140.92,-32.44 -209.32,-6.64 -68.3,25.77 -122.52,76.68 -152.67,143.21 -62.17,137.49 -0.9,299.92 136.6,362.09 66.62,30.12 140.92,32.44 209.22,6.68 68.4,-25.81 122.65,-76.63 152.77,-143.25 62.17,-137.49 0.9,-299.92 -136.6,-362.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    style: {
      fill: "#ffc359",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5755.86,4996.97 -498.59,-225.52 c -62.17,137.49 -0.9,299.92 136.6,362.09 66.62,30.12 140.92,32.44 209.22,6.68 68.4,-25.81 122.65,-76.63 152.77,-143.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3756.91,3424.12 246.48,0.31 0.06,-41.67 -271.23,-204.96 24.69,246.32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    style: {
      fill: "#ff95a9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3945.5,3368.22 c -22.83,37.83 -10.67,87 27.16,109.83 37.83,22.83 87,10.67 109.83,-27.15 22.83,-37.83 10.67,-87 -27.16,-109.83 -37.83,-22.83 -87,-10.68 -109.83,27.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    style: {
      fill: "#ff95a9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4072.06,3467.97 c 17.13,-28.37 54.01,-37.49 82.38,-20.37 28.37,17.12 37.49,54 20.36,82.37 -17.12,28.37 -54,37.49 -82.37,20.37 -28.37,-17.12 -37.49,-54 -20.37,-82.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    style: {
      fill: "#ff95a9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4072.91,3355.41 94.71,102.94 -75.19,91.99 -119.77,-72.29 100.25,-122.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4334.44,4118.43 c 71.51,-23.69 148.69,15.08 172.38,86.59 23.69,71.51 -15.08,148.69 -86.59,172.38 -71.51,23.69 -148.69,-15.08 -172.38,-86.59 -23.69,-71.52 15.08,-148.69 86.59,-172.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3711.51,4318.8 624.06,-200.74 107.86,249.21 -573.76,316.92 -158.16,-365.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4178.2,3474.3 -113.12,38.42 179.51,766.35 257.15,-87.35 -282.26,-625.82 -24.61,-54.62 -16.67,-36.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4178.2,3474.3 -113.12,38.42 26,110.99 128.4,-57.81 -24.61,-54.62 -16.67,-36.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    style: {
      fill: "#ff95a9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 4178.15,3474.27 -113.13,38.42 12.09,51.6 117.71,-53.04 -16.67,-36.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    style: {
      fill: "#c4b8ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3064.74,3424.43 -246.49,-0.31 0.06,-41.67 271.74,-204.28 -25.31,246.26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2922.69,4400.31 c 44.45,-101.12 162.46,-147.05 263.57,-102.6 101.12,44.46 147.06,162.46 102.6,263.58 -44.45,101.12 -162.46,147.05 -263.58,102.6 -101.11,-44.45 -147.05,-162.46 -102.59,-263.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3333.96,3358.29 c 3.37,-75.32 -54.95,-139.1 -130.26,-142.48 -75.31,-3.37 -139.1,54.94 -142.47,130.25 -3.37,75.32 54.94,139.1 130.25,142.48 75.31,3.37 139.1,-54.94 142.48,-130.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3774.99,3375.82 c 12.75,-74.3 -37.15,-144.87 -111.45,-157.62 -74.3,-12.75 -144.87,37.14 -157.62,111.45 -12.75,74.3 37.15,144.87 111.45,157.62 74.3,12.75 144.87,-37.15 157.62,-111.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3783.54,3489.41 -6.53,-136.51 -0.32,-6.69 c -3.47,-72.7 -63.38,-129.89 -136.17,-129.98 l -442.47,-0.56 c -72.79,-0.09 -132.84,56.95 -136.5,129.64 l -0.34,6.69 -6.87,136.49 729.2,0.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3333.93,3358.28 37.94,-846.55 -231.07,-10.35 -79.5,844.69 272.63,12.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3428.74,1239.7 c 2.09,-46.56 -33.97,-86 -80.53,-88.08 -46.57,-2.09 -86.01,33.96 -88.09,80.53 -2.09,46.56 33.97,86 80.53,88.09 46.56,2.08 86,-33.97 88.09,-80.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3307.46,4632.31 180.91,-720.47 126.76,510.26 -0.27,210.6 -307.4,-0.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3371.87,2511.74 c 2.86,-63.81 -46.55,-117.85 -110.36,-120.71 -63.81,-2.86 -117.85,46.55 -120.71,110.35 -2.86,63.81 46.55,117.86 110.36,120.72 63.8,2.86 117.85,-46.55 120.71,-110.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3260.24,1232.15 -119.44,1269.23 231.07,10.36 56.99,-1272.03 -168.62,-7.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path142",
    style: {
      fill: "#ff95a9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3553.35,4572.72 -249.06,21.72 32.16,368.81 249.05,-21.71 -32.15,-368.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path144",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3175.02,1135.93 h 253.81 v 100 h -168.9 L 3163,1183.06 c -8.06,-4.39 -13.08,-12.85 -13.08,-22.03 v 0 c 0,-13.87 11.24,-25.1 25.1,-25.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path146",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3671.52,1250.2 c 7.88,-45.94 -22.97,-89.57 -68.91,-97.45 -45.94,-7.89 -89.57,22.96 -97.45,68.9 -7.88,45.94 22.97,89.57 68.91,97.46 45.93,7.88 89.57,-22.97 97.45,-68.91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path148",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3757.74,1135.93 h -253.81 v 100 h 168.9 l 96.92,-52.87 c 8.07,-4.39 13.09,-12.85 13.09,-22.03 v 0 c 0,-13.87 -11.24,-25.1 -25.1,-25.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path150",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 3503.93,3352.89 V 1236.03 l 168.72,-4.34 104.16,2114.2 -272.88,7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path152",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3672.17,1222.09 -19.99,0.99 12.95,262.65 19.98,-0.99 -12.94,-262.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path154",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3688.92,1562.18 -19.98,0.98 38.6,783.14 19.98,-0.98 -38.6,-783.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path156",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3729.17,2378.73 -19.98,0.98 2.62,53.36 19.98,-0.98 -2.62,-53.36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5499.27,4713.52 c -4.87,0 -9.79,0.43 -14.72,1.31 -26.04,4.67 -50.72,13.99 -73.36,27.68 -34.26,20.71 -48.86,62.93 -34.73,100.39 l 4.89,12.97 18.72,-7.05 -4.9,-12.98 c -10.73,-28.44 0.36,-60.49 26.37,-76.22 20.54,-12.42 42.92,-20.86 66.54,-25.1 29.94,-5.37 59.43,11.37 70.15,39.8 9.74,25.82 1.73,54.66 -19.93,71.76 l -76.08,60.06 c -28.53,22.52 -39.08,60.51 -26.25,94.51 14.13,37.45 52.94,59.5 92.39,52.43 26.03,-4.67 50.72,-13.99 73.36,-27.68 34.25,-20.71 48.86,-62.93 34.73,-100.39 l -4.9,-12.98 -18.71,7.07 4.9,12.98 c 10.72,28.43 -0.36,60.48 -26.38,76.21 -20.53,12.42 -42.92,20.86 -66.54,25.11 -29.91,5.36 -59.4,-11.38 -70.13,-39.81 -9.75,-25.82 -1.74,-54.65 19.93,-71.76 l 76.07,-60.06 c 28.53,-22.51 39.07,-60.49 26.25,-94.5 -12.36,-32.77 -43.65,-53.75 -77.67,-53.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5572.14,5029.72 -18.71,7.06 21.45,56.87 18.71,-7.06 -21.45,-56.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5438.25,4674.83 -18.71,7.05 21.44,56.87 18.71,-7.06 -21.44,-56.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    style: {
      fill: "#ddd6ff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 5329.2,4419.78 -19.71,3.41 c 10.88,62.86 20.94,97.45 21.36,98.89 l 19.2,-5.62 c -0.11,-0.35 -10.19,-35.08 -20.85,-96.68 z m -22.39,-197.56 -19.96,1.18 c 2,33.75 4.88,67.45 8.54,100.17 l 19.88,-2.23 c -3.63,-32.37 -6.47,-65.72 -8.46,-99.12 z m -22.06,-199.71 c -0.97,26.33 -1.47,52.93 -1.47,79.06 0,7.21 0.04,14.34 0.11,21.39 l 20,-0.19 c -0.07,-6.99 -0.11,-14.06 -0.11,-21.2 0,-25.88 0.49,-52.23 1.45,-78.32 z m 16.72,-200.16 c -4.3,33.09 -7.89,66.7 -10.66,99.88 l 19.92,1.67 c 2.75,-32.88 6.31,-66.18 10.57,-98.97 z m 34.76,-197.8 c -7.24,32.52 -13.83,65.67 -19.61,98.51 l 19.71,3.46 c 5.71,-32.55 12.25,-65.39 19.43,-97.62 z m 50.05,-193.77 c -4.42,18.42 -9.4,37.21 -14.79,55.85 -3.9,13.54 -7.66,27.01 -11.28,40.39 l 19.32,5.21 c 3.57,-13.27 7.29,-26.62 11.18,-40.05 5.47,-18.92 10.53,-38.02 15.02,-56.74 z m 28.41,-195.73 c -1.4,32.04 -4.6,65.17 -9.51,98.47 l 19.79,2.92 c 5.01,-33.98 8.27,-67.79 9.7,-100.52 z M 3924.04,3069.06 c -4.67,7.09 -9.31,14.25 -13.91,21.5 l 16.88,10.72 c 4.54,-7.15 9.12,-14.23 13.73,-21.22 z m 1494.88,-34.42 -19.55,4.18 c 6.7,31.38 11.37,64.19 13.88,97.53 l 19.94,-1.5 c -2.57,-34.24 -7.37,-67.95 -14.27,-100.21 z M 4046.15,2909.12 c -21.89,24.71 -43.4,50.89 -63.93,77.81 l 15.9,12.13 c 20.24,-26.54 41.43,-52.34 62.99,-76.68 z m 1300.74,-63.4 -17.28,10.05 c 16.25,27.95 30.42,57.79 42.12,88.68 l 18.71,-7.08 c -12.09,-31.92 -26.74,-62.75 -43.55,-91.65 z m -1155.65,-76.23 c -25.72,20.92 -51.09,43.42 -75.41,66.88 l 13.88,14.39 c 23.92,-23.07 48.87,-45.19 74.14,-65.76 z m 1025.26,-78.52 -12.83,15.33 c 25.11,21.02 48.5,44.32 69.49,69.25 l 15.29,-12.88 c -21.73,-25.82 -45.94,-49.95 -71.95,-71.7 z m -858.08,-34.04 c -29.16,15.87 -58.17,33.51 -86.22,52.43 l 11.2,16.58 c 27.52,-18.57 55.96,-35.87 84.57,-51.44 z m 683.43,-68.02 -7.17,18.68 c 30.85,11.84 60.68,26.11 88.65,42.4 l 10.06,-17.29 c -28.89,-16.82 -59.68,-31.55 -91.54,-43.79 z m -497.37,-9.8 c -31.82,9.49 -63.81,20.95 -95.09,34.07 l 7.74,18.44 c 30.61,-12.84 61.93,-24.06 93.07,-33.35 z m 300.03,-33.95 -1.52,19.94 c 33.06,2.54 65.85,7.34 97.45,14.29 l 4.29,-19.53 c -32.51,-7.15 -66.23,-12.09 -100.22,-14.7 z m -101.21,-1.07 c -33.2,1.79 -67,5.71 -100.48,11.65 l 3.5,19.69 c 32.67,-5.8 65.67,-9.62 98.05,-11.37 l -1.07,-19.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3963.15,4447.95 c -33.83,-105.15 -146.49,-162.97 -251.64,-129.15 -105.15,33.83 -162.97,146.49 -129.15,251.64 33.83,105.15 146.49,162.97 251.64,129.15 105.15,-33.83 162.97,-146.49 129.15,-251.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3831.18,4486.11 -47.64,-996.7 -729.2,-0.92 -50.15,996.58 c -4.02,79.91 59.63,146.93 139.65,147.03 l 547.32,0.69 c 80.02,0.11 143.84,-66.76 140.02,-146.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3614.86,4632.69 0.27,-210.6 -52.83,-212.56 -73.93,-297.7 -74.67,297.51 -106.24,422.96 307.4,0.39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3562.3,4209.53 -73.93,-297.7 -74.67,297.51 63.82,375.38 20,0.02 64.78,-375.21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    style: {
      fill: "#ff95a9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2933.02,3339.82 c 22.83,37.83 10.68,87 -27.15,109.83 -37.83,22.83 -87,10.68 -109.83,-27.15 -22.83,-37.83 -10.67,-87 27.15,-109.83 37.83,-22.83 87,-10.67 109.83,27.15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    style: {
      fill: "#ff95a9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2806.46,3439.57 c -17.12,-28.37 -54,-37.49 -82.37,-20.37 -28.37,17.12 -37.49,54 -20.37,82.37 17.12,28.37 54,37.49 82.37,20.37 28.38,-17.12 37.49,-54 20.37,-82.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    style: {
      fill: "#ff95a9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2805.62,3327.01 -94.71,102.95 75.18,91.98 119.78,-72.29 -100.25,-122.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2544.08,4090.03 c -71.51,-23.69 -148.69,15.08 -172.37,86.59 -23.69,71.51 15.07,148.69 86.59,172.38 71.51,23.69 148.69,-15.08 172.38,-86.59 23.69,-71.51 -15.08,-148.69 -86.6,-172.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path182",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3167.01,4290.41 -624.05,-200.75 -107.86,249.21 573.76,316.92 158.15,-365.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2700.32,3445.9 113.13,38.42 -179.51,766.35 -257.16,-87.35 282.27,-625.81 24.6,-54.63 16.67,-36.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2700.32,3445.9 113.13,38.42 -26,110.99 -128.4,-57.8 24.6,-54.63 16.67,-36.98"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path188",
    style: {
      fill: "#ff95a9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2700.38,3445.88 113.12,38.41 -12.08,51.6 -117.71,-53.04 16.67,-36.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path190",
    style: {
      fill: "#7760db",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2915.38,4419.55 c 33.82,-105.15 146.48,-162.97 251.63,-129.14 105.16,33.82 162.98,146.48 129.15,251.63 -33.82,105.15 -146.48,162.97 -251.63,129.15 -105.15,-33.82 -162.98,-146.49 -129.15,-251.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path192",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3792.09,4978.46 -35.8,6.29 42.47,241.69 35.8,-6.29 c 66.74,-11.73 111.34,-75.34 99.61,-142.08 v 0 c -11.73,-66.74 -75.34,-111.34 -142.08,-99.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path194",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3457.63,4801.86 -89.51,15.73 c -49.44,8.69 -82.47,55.81 -73.79,105.25 l 17.23,98.05 179.03,-31.46 -32.96,-187.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path196",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3768.99,4988.95 -97.19,17.08 54.65,311.01 86.9,-15.27 c 59.33,-10.43 98.97,-66.97 88.54,-126.29 l -18.71,-106.47 c -9.42,-53.64 -60.55,-89.49 -114.19,-80.06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path198",
    style: {
      fill: "#ff95a9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3678.9,4669.2 -228.42,40.14 c -49.37,8.68 -82.36,55.73 -73.69,105.1 l 47.18,268.49 c 19.13,108.86 122.89,181.6 231.75,162.47 v 0 c 105.15,-18.48 177.28,-116.25 163.91,-222.17 l -34.83,-275.9 c -6.51,-51.51 -54.77,-87.11 -105.9,-78.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path200",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3545.09,5299.55 26.82,-4.71 -59.22,-336.98 -205.85,36.17 27.76,157.95 c 17.37,98.88 111.61,164.94 210.49,147.57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path202",
    style: {
      fill: "#ff95a9",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3399.38,4943.17 53.71,-9.44 9.44,53.71 c 5.21,29.66 -14.61,57.93 -44.27,63.14 v 0 c -29.67,5.22 -57.94,-14.6 -63.15,-44.27 v 0 c -5.21,-29.66 14.61,-57.93 44.27,-63.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path204",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3857.28,5072.57 -203.91,35.83 c -83.1,14.6 -138.83,94.09 -124.22,177.2 6.95,39.55 44.64,65.97 84.19,59.02 39.55,-6.95 65.98,-44.64 59.03,-84.19 -0.73,-4.13 2.04,-8.08 6.17,-8.81 l 203.91,-35.83 -25.17,-143.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path206",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3793.78,5157.56 -101.45,17.82 c -39.54,6.95 -65.97,44.65 -59.02,84.2 6.95,39.55 44.64,65.97 84.19,59.02 l 101.44,-17.82 c 39.55,-6.95 65.98,-44.65 59.03,-84.2 -6.95,-39.55 -44.65,-65.97 -84.19,-59.02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path208",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3775.63,4674.28 c -5.21,-41.22 -43.83,-69.77 -84.81,-62.57 l -142.31,25.01 c -79.09,13.9 -131.94,89.28 -118.04,168.37 l 29.45,167.63 53.68,-9.43 v 0 c -5.8,-32.96 16.23,-64.38 49.19,-70.18 l 235.2,-41.32 -22.36,-177.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path210",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3644.66,4762.27 c 4.22,25.02 28.05,42.56 52.94,37.64 21.08,-4.18 32.02,-28.53 27.53,-51.24 l -80.47,13.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path212",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3368.07,2199.69 -46.43,1036.08 155.95,0.21 0.02,-20 -135.05,-0.18 45.49,-1015.22 -19.98,-0.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path214",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3375.41,2035.94 -3.63,80.97 19.98,0.89 3.63,-80.97 -19.98,-0.89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path216",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3787.09,3563.81 -19.98,0.95 8.25,172.54 19.98,-0.95 -8.25,-172.54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path218",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3797.53,3782.2 -19.98,0.95 1.54,32.39 19.98,-0.96 -1.54,-32.38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path220",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3802.46,3885.43 -19.98,0.96 20.25,424.01 379.93,-122.2 -6.13,-19.04 -355.07,114.21 -19,-397.94"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path222",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2755.79,3642.63 -8.06,34.39 19.47,4.57 8.06,-34.4 -19.47,-4.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path224",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2735.23,3730.44 -96.27,411.14 193.1,62.09 6.11,-19.05 -175.54,-56.43 92.07,-393.19 -19.47,-4.56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path226",
    style: {
      fill: "#40327a",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2880.48,4198.23 -6.12,19.04 199.48,64.13 6.12,-19.04 -199.48,-64.13"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyPockets);
export default __webpack_public_path__ + "static/media/emptyPockets.c1a95a616cbc9fb72ae3d6b5b93b1d26.svg";
export { ForwardRef as ReactComponent };